export const SET_PREVIEW_MEDIA = 'SET_PREVIEW_MEDIA';
